import React, { useState } from "react";
import { getOptionsStatusBusiness } from "@/shared/constants/constants";
import PaginationUI from "../atoms/PaginationUI";
import ColumnButton from "../molecules/ColumnButton";
import ColumnDropdown from "../molecules/ColumnDropdown";
import ColumnLabels from "../molecules/ColumnLabels";
import ColumnPersonInformationAvatar from "../molecules/ColumnPersonInformationAvatar";
import ColumnText from "../molecules/ColumnText";
import ColumnTitleDate from "../molecules/ColumnTitleDate";
import LoadTable from "./LoadTable";

export type RecoveryOldPageProps = {
  id: number;
  name: string;
  avatar: string;
  email: string;
  branch: {
    branch: string;
    gym: {
      gym: string;
    };
  };
  state_fee: {
    date_finish: string;
  };
  tasks: string;
  stages: string;
  user_tags: string[];
  marketing_tags: string[];
  tickets: string[];
  payments: string[];
  incidents: string[];
};

export type TableListRecoveryOldProps = {
  people: RecoveryOldPageProps[];
  loader: boolean;
};

const TableListRecoveryOld: React.FC<TableListRecoveryOldProps> = ({
  people,
  loader,
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 20;

  const optionsStatusBusiness = getOptionsStatusBusiness();

  if (loader) {
    return <LoadTable />;
  }

  const totalResults = people.length;
  const totalPages = Math.ceil(totalResults / pageSize);
  const startIndex = (currentPage - 1) * pageSize;
  const currentPeople = people.slice(startIndex, startIndex + pageSize);

  return (
    <div className="px-4 sm:px-6 lg:px-0">
      <div className="mt-2 flow-root ">
        <div className="-mx-4 -my-2 overflow-x-auto overflow-y-hidden sm:-mx-6 lg:-mx-8 max-h-[65vh]">
          <div className="inline-block min-w-full  py-2 align-middle sm:px-6 lg:px-8 ">
            <div className="overflow-y-auto max-h-[65vh]">
              <table className="min-w-full divide-y divide-gray-300  px-4 ">
                <thead>
                  <tr>
                    <th className="sticky top-0 z-10 border-b border-gray-300 bg-white bg-opacity-75 py-3.5 pl-4 text-left text-sm font-semibold text-gray-900 backdrop-blur backdrop-filter sm:pl-6 lg:pl-8">
                      Usuario
                    </th>
                    <th className="sticky top-0 z-10 border-b border-gray-300 bg-white bg-opacity-75 px-3 py-3.5 text-left text-sm font-semibold text-gray-900 backdrop-blur backdrop-filter">
                      Compañía & Filial
                    </th>
                    <th className="sticky top-0 z-10 border-b border-gray-300 bg-white bg-opacity-75 px-3 text-left text-sm font-semibold text-gray-900 backdrop-blur backdrop-filter">
                      Información de pago
                    </th>
                    <th className="sticky top-0 z-10 border-b border-gray-300 bg-white bg-opacity-75 px-3 text-left text-sm font-semibold text-gray-900 backdrop-blur backdrop-filter">
                      Tareas
                    </th>
                    <th className="sticky top-0 z-10 border-b border-gray-300 bg-white bg-opacity-75 px-3 py-3.5 text-left text-sm font-semibold text-gray-900 backdrop-blur backdrop-filter">
                      Etapas del negocio
                    </th>
                    <th className="sticky top-0 z-10 border-b border-gray-300 bg-white bg-opacity-75 px-3 py-3.5 text-left text-sm font-semibold text-gray-900 backdrop-blur backdrop-filter">
                      Etiquetas usuario
                    </th>
                    <th className="sticky top-0 z-10 border-b border-gray-300 bg-white bg-opacity-75 px-3 py-3.5 text-left text-sm font-semibold text-gray-900 backdrop-blur backdrop-filter">
                      Etiquetas marketing
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200 bg-white">
                  {currentPeople.map((person) => (
                    <tr key={person?.id}>
                      <ColumnPersonInformationAvatar
                        id={person?.id}
                        open_user={true}
                        name={person?.name}
                        image={
                          person?.avatar ??
                          "https://dash.fitmewise.com/uploads/users/profile.png"
                        }
                        email={person?.email}
                      />
                      {person?.branch ? (
                        <ColumnText
                          title={`${person?.branch?.gym?.gym}/${person?.branch?.branch}`}
                        />
                      ) : (
                        <ColumnText title={`Desconocido`} />
                      )}
                      <ColumnTitleDate
                        title={"Con retraso"}
                        date={person?.state_fee?.date_finish}
                      />
                      <ColumnText title={person?.tasks} />
                      <ColumnDropdown
                        lastPeople={people}
                        selected={person.stages}
                        person={person}
                        options={optionsStatusBusiness}
                      />
                      <ColumnLabels labels={person?.user_tags} />
                      <ColumnLabels labels={person?.marketing_tags} />
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div className="flex-shrink-0">
        <PaginationUI
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={(page) => setCurrentPage(page)}
          pageSize={pageSize}
          totalResults={totalResults}
        />
      </div>
    </div>
  );
};

export default TableListRecoveryOld;
